// components/screener/FilterPanel.jsx
import React from 'react';
import { Grid, Box, Collapse } from '@mui/material';
import FilterCard from './FilterCard';

const FilterPanel = ({ filters, onRemove, onUpdate, filterOptions, isExpanded = true }) => {
    if (filters.length === 0) return null;

    return (
        <Collapse in={isExpanded} timeout={300}>
            <Box sx={{ mt: 1.5, mb: 1 }}>
                <Grid container spacing={1.5}>
                    {filters.map((filter) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={filter.id}>
                            <FilterCard
                                filter={filter}
                                onRemove={onRemove}
                                onUpdate={onUpdate}
                                filterOptions={filterOptions}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Collapse>
    );
};

export default FilterPanel;
